<template>
  <el-dialog
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :title="$t('navbar.orderImport')"
    :visible.sync="importDialog"
    width="550px"
    @close="handleDialog"
  >
    <el-form
      ref="ruleForm" :model="ruleForm" class="demo-ruleForm"
      label-width="auto"
    >
      <div style="margin: 20px 0">
        <span class="downModule" @click="downLoadFile">{{
          $t('orderCenterCont.DownloadTemplate')
        }}</span>
        <span style="font-size: 12px; color: red">{{
          $t('customerManagements.pleaseUploadLI')
        }}</span>
      </div>
      <el-form-item prop="">
        <template slot="label">
          <el-button
            size="small" type="primary" @click="triggerFileInput"
          >{{ $t('customerManagements.clickUpload') }}
          </el-button>
        </template>
        <input
          ref="referenceUpload"
          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          style="display: none"
          type="file"
          @change="uploadFile($event)"
        >
      </el-form-item>
      <div v-if="fileName" class="downLink">
        <div>{{ fileName }}</div>
        <div><i class="el-icon-error" @click="delFile" /></div>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="handleDialog">{{ $t('GlobalSetObj.cancel') }}</el-button>
      <el-button
        size="small" type="primary" @click="confirmImport"
      >{{ $t('GlobalSetObj.confirm') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
// 校验函数：确保输入为数字
import { downloadFlowDirectNameApi, importData } from '@/api/newExpressAPI';

export default {
  data() {
    return {
      ruleForm: {
        // file: ''
      },
      importDialog: false,
      fileName: '',
      fileData: null,
      sizeFile: ''
    };
  },
  methods: {
    handleDialog() {
      this.delFile();
      this.importDialog = false;
    },
    // 上传文件
    uploadFile(e) {
      this.fileData = e.target.files[0];
      this.fileName = e.target.files[0].name;
      this.sizeFile = e.target.files[0].size;
    },
    confirmImport() {
      const formData = new FormData();
      // 如果有文件上传
      if (this.fileName) {
        formData.append('sizeFile', this.sizeFile);
        formData.append('file', this.fileData);
        formData.append('fileName', this.fileName);
        importData(formData).then((res) => {
          this.importDialog = false;
          this.$emit('invoke-search', res.data);
        });
      } else {
        this.$message.error(this.$t('routes.pleaseUploadFile'));
        return;
      }
    },
    // 删除文件
    delFile() {
      this.fileName = '';
      this.fileData = null;
      this.sizeFile = '';
      this.$refs.referenceUpload.value = '';
    },
    triggerFileInput() {
      this.$refs.referenceUpload.click();
    },
    // 控制弹框
    openDialog() {
      this.importDialog = true;
    },
    // 下载模板
    downLoadFile() {
      console.log('下载模板');
      downloadFlowDirectNameApi().then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'table_data.csv'); // 更改为实际的文件名和扩展名
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url); // 清理 URL
      });
    }
  }
};
</script>

<style scoped>
.downModule {
  color: #00A551;
  text-decoration: underline;
  cursor: pointer;
  margin-right: 15px;
}

.downLink {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f5f7fa;
  cursor: pointer;
  padding: 5px;
}
</style>
